

import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import './services.css';

const servicesData = [
  {
    icon: 'ri-code-line',
    title: 'Web Design',
    desc: 'Web design refers to the design of websites that are displayed on the internet. It usually refers to the user experience aspects of website development rather than software development.'
  },

  {
    icon: 'ri-code-s-slash-line',
    title: 'Web Development',
    desc: 'Web development is the building and maintenance of websites; it is the work that happens behind the scenes to make a website look great, work fast and perform well with a seamless user experience.'
  },
  {
    icon: 'ri-computer-line',
    title: 'UI / UX Design',
    desc: 'UX stands for “user experience,” and UI stands for “user interface.” You will often see them lumped together as they are two closely related professions that often work hand-in-hand.'
  },
  {
    icon: 'ri-cloud-line',
    title: 'Web Hosting',
    desc: 'Web hosting is the process by which your website, including its content and files (as well as its code and images), is delivered to the internet.'
  },
  {
    icon: 'ri-landscape-line',
    title: 'Graphics Design',
    desc: 'Graphic design is a craft where professionals create visual content to communicate messages. By applying visual hierarchy and page layout techniques.'
  },
  {
    icon: 'ri-search-line',
    title: 'SEO',
    desc: 'Search Engine Optimization is the practice of optimizing a website so that it ranks well on search engines. Website design is the design and creation of a website.'
  },

]

const Services = () => {
  return (
    <section id="services">
      <Container>
        <Row>
          <Col lg='12' className='service-top mb-5'>
            <h6>Features</h6>
            <h2>What services I provide</h2>
          </Col>
          
          {
            servicesData.map((item, index)=>(
              <ServicesItem
                key={index}
                icon={item.icon}
                title={item.title}
                desc={item.desc}
              />
            ))
          }

        </Row>
      </Container>
    </section>
  )
}

const ServicesItem = ({icon, title, desc})=>{
  return <Col lg='4' md='6' sm='6' className='mb-4'>
          <div className="single-service">
            <span className="service-icon">
              <i className={icon}></i>
            </span>

            <h2>{title}</h2>

            <p>
              {desc}
            </p>
          </div>
        </Col>
}

export default Services